module.exports = __webpack_public_path__ + "img/Mike Rogers.0259215f.jpg";